import {VesselTag} from '../../../../../../api/vessel-tags'

export interface FleetScoreOverTimeFilter {
    searchedVesselTagTerm: VesselTag | undefined
}

export const DEFAULT_FLEET_SCORE_OVER_TIME_FILTERS: FleetScoreOverTimeFilter = {
    searchedVesselTagTerm: undefined,
}
